const serverURL = ""; //proxied via nginx /api → https://sandbox.swinkpay-fintech.com
let extra;
const GetAPI = (target, pg, token = "") => {
  if (target === "timeout") {
    extra = token;
  }
  switch (target) {
    case "bank":
      return serverURL + "/api/v2/consumer/bd/nb/banklist";
    case "qrCode":
      return serverURL + "/api/v1/getterminalqr";
    case "timeout":
      return serverURL + "/api/v2/validateurl/" + token;
    case "validateVPA":
      return serverURL + "/api/v2/validatevpa";
    case "apbValidateVPA":
      return serverURL + "/api/v2/apb/validateVPA";
    case "decision":
      return serverURL + "/api/v2/plugin/decision";
    case "validateURL":
      return serverURL + "/api/v2/validateurl/" + extra;
    case "firstLeg":
      if (pg === 8) {
        return serverURL + "/api/v2/plugin/cf/firstleg";
      } else if (pg === 2) {
        return serverURL + "/api/v2/plugin/bd/firstleg";
      } else if (pg === 10) {
        return serverURL + "/api/v3/plugin/initiatePayment";
      } else if (pg === 12) {
        return serverURL + "/api/v2/plugin/apb/firstleg";
      } else if (pg === 15) {
        return serverURL + "/api/v2/plugin/eb/firstleg";
      }
    case "apiForValidToken":
      return serverURL + "/api/v2/payment/data";
    case "apiForValidTransactionId":
      return serverURL + "/api/v2/payment/auth";
    case "apiGetBinData":
      return serverURL + "/api/v2/plugin/cf/cardbin";
    case "activity":
      return serverURL + "/api/v2/plugin/activity";
    default:
      return null;
  }
};

export default GetAPI;
